module.exports = __webpack_public_path__ + "static/media/marker-shadow.44a526ee.png";